// extracted by mini-css-extract-plugin
module.exports = {"player-icon-mask":"eC","playerIconMask":"eC","player-icon-box":"eD","playerIconBox":"eD"};